<template>
  <div>
    <v-card max-width="530px">
      <v-card-title class="d-flex justify-center mb-n3">
        {{ $tc("gestionTiempos.addRegistration") }}
      </v-card-title>
      <div>
        <v-alert
          dense
          v-if="error"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mx-5"
        >
          {{ alertValidate }}</v-alert
        >

        <v-form
          @submit.prevent="submitForm"
          class="ml-5 mr-5"
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-autocomplete
            :label="$tc('gestionEmpleados.employees')"
            :items="getEmployee"
            required
            name="employee"
            :rules="rules"
            item-text="label"
            item-value="empId"
            outlined
            v-model="data.employee"
            dense
          />
          <v-autocomplete
            :label="$tc('editRegistrations.concept')"
            :items="getConcepts"
            required
            name="concept"
            :rules="rules"
            :item-text="formatConcept"
            item-value="conceptId"
            outlined
            v-model="data.concept"
            @change="conceptsHours"
            dense
          />

          <div class="mx-3">
            <DateRegis :showCheck="true" />
          </div>

          <div class="d-flex my-6">
            <v-text-field
              v-if="showHours"
              required
              :rules="rules"
              label="Hora de entrada"
              name="start"
              style="max-width: 235px"
              hide-details
              v-model="data.timeStartDay"
              dense
              outlined
              @input="data.timeStartDay = formatedHour(data.timeStartDay)"
              class="mr-4"
            />
            <v-text-field
              v-if="showHours"
              label="Hora de salida"
              v-model="data.timeEndDay"
              style="max-width: 235px"
              hide-details
              name="end"
              required
              :rules="rules"
              dense
              outlined
              @input="data.timeEndDay = formatedHour(data.timeEndDay)"
            />
          </div>

          <v-autocomplete
            :label="$tc('editRegistrations.csCosts')"
            required
            :rules="rules"
            name="cost"
            :items="getCosts"
            item-text="name"
            item-value="id"
            outlined
            v-model="data.cost"
            dense
          />
          <v-autocomplete
            :label="$tc('editRegistrations.audit')"
            outlined
            :items="getAudit"
            name="audit"
            :required="showAudit == true"
            :rules="rules"
            item-text="comment"
            item-value="id"
            v-model="data.audit"
            v-if="showAudit"
            dense
          />
          <v-textarea
            :label="$tc('editRegistrations.observations')"
            color="primary"
            rows="1"
            outlined
            name="obs"
            v-model="data.observations"
          />
          <div class="d-flex justify-space-between pb-4">
            <v-btn class="bt-exit" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <v-btn type="submit" class="bt-acept ml-3">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-form>
      </div>
    </v-card>
  </div>
</template>
<script>
import registrations from "../../store/gestionTiempos/registrations";
import moment from "moment";
import DateRegis from "./Actions/common/DateRegis.vue";

export default {
  components: { DateRegis },
  props: {
    errorValidate: Boolean,
    alertMessageValidate: String,
  },
  data() {
    return {
      data: {
        concept: 1,
        timeStartDay: "00:00",
        timeEndDay: "00:00",
        cost: 1,
        audit: 1,
        observations: "",
        employee: null,
      },
      showHours: true,
      showAudit: false,
      startTimeMenu: false,
      endMenuTime: false,
      audit: localStorage.getItem("auditRegis"),
      valid: true,
      error: false,
      alertValidate: "",
      rules: [(v) => !!v || this.$tc("editRegistrations.required")],
      errorRegistration: false,
      alertMessageRegistration: "",
    };
  },
  mounted() {
    this.auditTrue();
    this.$store.commit(
      "gestionTiempos/setDateFromComponents",
      moment().format("YYYY-MM-DD")
    );
    this.$store.commit(
      "gestionTiempos/setDateToComponents",
      moment().format("YYYY-MM-DD")
    );
  },
  computed: {
    getEmployee() {
      return this.$store.state.gestionTiempos.itemsEmployees;
    },
    getConcepts() {
      return registrations.state.concepts;
    },
    getCosts() {
      return registrations.state.csCosts;
    },
    getAudit() {
      return registrations.state.audit;
    },
  },
  methods: {
    formatConcept(item) {
      if (!item || !item.name) return "";
      const tipo =
        item.licTot === "S" ? " (Días)" : item.licTot === "N" ? " (Horas)" : "";
      return `${item.name}${tipo}`;
    },
    conceptsHours() {
      this.showHours = true;
      const concept = registrations.state.concepts.find(
        (item) => item.conceptId == this.data.concept
      );
      if (concept.licTot === "S") {
        this.showHours = false;
      }
    },
    cancel() {
      this.reset();
      this.$emit("cancel", false);
    },
    reset() {
      this.$refs.form.resetValidation();
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      (this.data = {
        concept: 1,
        timeStartDay: "00:00",
        timeEndDay: "00:00",
        cost: 1,
        audit: 1,
        observations: "",
        employee: null,
      }),
        this.$store.commit("gestionTiempos/setDateFromComponents", day);
      this.$store.commit("gestionTiempos/setDateToComponents", day);
      this.showHours = true;
    },
    formatDate(date, hour) {
      const hourFormat = !hour ? "00:00" : hour;
      return `${date}T${hourFormat}:00.000`;
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        const from = this.$store.state.gestionTiempos.dateFromComponents;
        const to = this.$store.state.gestionTiempos.dateToComponents;
        if (this.showHours) {
          if (
            moment(this.formatDate(from, this.data.timeStartDay)).isSame(
              this.formatDate(to, this.data.timeEndDay)
            )
          ) {
            this.error = true;
            this.alertValidate = this.$tc("alert.errorDate");
            setTimeout(() => {
              this.error = false;
            }, 3500);
            return;
          }
        }

        if (moment(from).isAfter(to)) {
          this.error = true;
          this.alertValidate = this.$tc("alert.errorDates");
          setTimeout(() => {
            this.error = false;
          }, 3500);
          return;
        }
        const startDateTime = moment(
          `${from}T${this.data.timeStartDay}:00.000Z`
        );
        const endDateTime = moment(`${to}T${this.data.timeEndDay}:00.000Z`);

        if (endDateTime.isBefore(startDateTime)) {
          this.error = true;
          this.alertValidate = this.$tc("gestionTiempos.invalidTimeRange");
          setTimeout(() => {
            this.error = false;
          }, 2500);
          return;
        } else {
          this.handleSubmit(form);
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {
        entry: this.$store.state.gestionTiempos.dateFromComponents,
        exit: this.$store.state.gestionTiempos.dateToComponents,
      };

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.reset();
      this.$emit("save", itemsComplete);
    },
    auditTrue() {
      if (this.audit === "true") {
        this.showAudit = true;
      }
    },
    formatedHour(input) {
      let data = input; // Aquí, input ya es el valor del campo de entrada directamente

      if (data === "") {
        return "00:00"; // Si no hay entrada, establece el valor predeterminado como '00:00'
      } else if (!/^[0-9:]+$/.test(data)) {
        return "00:00"; // Si la entrada no es válida, establece el valor predeterminado como '00:00'
      } else {
        data = data.replace(/[^\d:]/g, ""); // Elimina cualquier carácter que no sea número o ':'
        // Si la longitud de la cadena es mayor o igual a 2 y no hay ':', inserta ':' después de los primeros 2 caracteres
        if (data.length >= 2 && data.indexOf(":") === -1) {
          data = data.substring(0, 2) + ":" + data.substring(2);
        }

        data = data.substring(0, 5); // Asegúrate de que la cadena tenga un máximo de 5 caracteres (HH:MM)

        const [horas, minutos] = data.split(":").map(Number);

        // Si los minutos son inválidos, establece los minutos a 59
        if (!isNaN(minutos) && minutos > 59) {
          data = `${horas}:59`;
        }

        // Si las horas son inválidas, establece las horas a 24
        if (!isNaN(horas) && horas > 24) {
          data = "24:00";
        }
      }

      return data; // Devuelve el valor formateado
    },
  },
};
</script>
<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.small {
  font-size: x-large;
  align-content: center;
}
</style>
